<style lang="scss" scoped>
@import "core";

.dn-loading-spinner {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



<template>
  <div :class="classes">
    <dn-spinner />
  </div>
</template>



<script>



export default {
  data() {
    return {
    }
  },



  computed: {
    classes() {
      return {
        'dn-loading-spinner': true,
      }
    },
  },

  methods: {
  },
}
</script>


// WEBPACK FOOTER //
// LoadingSpinner.vue?482fa820